import React from 'react';
import { get } from 'lodash';
import { useGlobalContext } from '../../context/GlobalContext';

export const AuctionRibbon = ({ position = 'top', auction = {} }) => {
    const globalContext = useGlobalContext();
    const { authed } = globalContext.user;

    const getIsCurrentBidder = ({ user = { is_high_bidder: false } }) => (
        user.is_high_bidder === true
            ? { text: 'High Bidder', text_modifier: 'high-bidder' }
            : { text: 'Outbid', text_modifier: 'outbid' }
    );

    const { text, text_modifier } = getIsCurrentBidder(auction);

    if (!authed || get(auction, 'user.is_bidder', false) === false) {
        return null;
    }

    return (
        <div className={`ribbon ${text_modifier} ${position}`}>
            <div className="ribbon-triangle" />
            <div className="ribbon-text">
                {text.toUpperCase()}
            </div>
        </div>
    );
};

